import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './utils/analytics';
// Side-effect import: installs global axios + fetch interceptor that attaches
// Authorization: Bearer <authToken|customer_jwt> on every ridenrepair.com
// call. Must run before any component fires its first request.
import './utils/auth_interceptor';

// Capture-everything analytics — armed before React renders so even the
// first click is recorded. Idempotent; safe under hot-reload.
initAnalytics();

// Render the App component (reverted from hydrate to fix performance issues)
ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
